







import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Card, CardSubmitEvent } from '.';
// @ts-ignore
import { renderElements, getStyles } from '@netcall/card-renderer';
import shortid from 'shortid';

@Component
export default class CardRenderer extends Vue {
	@Prop() public cards: Card[];
	@Prop() public colour: string;
	@Prop({ default: false }) public readonly: boolean;
	@Prop() public location: string;

	public id: string = `nc_${shortid.generate()}`;

	public $refs: {
		cardContainer: HTMLElement,
	};

	@Watch('cards')
	public onCardChange(cards: Card[], previous: Card[]) {
		this.renderCards(cards);
	}

	public mounted() {
		this.renderCards(this.cards);
		document.addEventListener('fresco-panel-submit', this.cardSubmitHandler);
	}

	public beforeDestroy() {
		document.removeEventListener('fresco-panel-submit', this.cardSubmitHandler);
	}

	public getStyles() {
		return getStyles(this.colour, this.id).innerHTML;
	}

	private renderCards(cards: Card[]) {
		if (!this.$refs.cardContainer) {
			return;
		}

		this.$refs.cardContainer.innerHTML = '';
		cards.forEach(card => this.renderCard(card));
	}

	private renderCard(card: Card) {
		if (this.isCardComponentsValid(card)) {
			const cardJson = JSON.stringify(card.content.components);
			renderElements(card.id || '', cardJson, this.$refs.cardContainer, this.location, this.readonly);
		} else {
			this.renderError(card);
		}
	}

	private renderError(card: Card) {
		renderElements(card.id || '', '{}', this.$refs.cardContainer, this.location, this.readonly);
	}

	private isCardComponentsValid(card: Card) {
		return card.content && card.content && card.content.components && card.content.components.length > 0;
	}

	private cardSubmitHandler(e: Event) {
		const customEvent = e as CustomEvent;
		this.onSubmit(customEvent.detail);
	}

	private onSubmit(e: CardSubmitEvent) {
		this.$emit('submit', e);
	}
}
